


<!-- <header id="navbar" #nav (scroll)="onWindowScroll($event);"> -->
<header id="navbar" #nav >
  <!-- <nav class="upper-nav">
  <div class="nav-none">
    <a href="https://lacounty.gov" target="_blank"><p>lacounty.gov</p></a>
  </div>
  <div class="upper-nav-right">

    <div class="btn-group nav-none" ngbDropdown>
      <a id="dropdownBasic2" ngbDropdownToggle>
        <p>{{"NavMenu.Font" | translate}} </p>
      </a>
      <ul  ngbDropdownMenu class="dropdown-menu p-1"
        aria-labelledby="dropdownBasic2">

        <div class="container-fluid p-0">
          <div class="row m-0">
            <div class="col-4 border" style="cursor: pointer;" (click)="downFont()"><i class="fas fa-minus"></i></div>
            <div  style="font-size: .8rem" class="col-4 border text-center p-0">{{baseNumber | number: '1.0-0'}}%</div>
            <div class="col-4 border" style="cursor: pointer;" (click)="upFont()"><i class="fas fa-plus"></i></div>

          </div>
        </div>
      </ul>
    </div>
    <div class="btn-group lang-btn" ngbDropdown #myDrop="ngbDropdown">
      <div ngbDropdownToggle aria-controls="dropdown-basic">
        <p style="cursor: pointer;">{{currentLang.name}}</p>
      </div>
      <ul   ngbDropdownMenu class="dropdown-menu translation "
        role="menu" aria-labelledby="button-animated">
        <div *ngFor="let item of languages">
          <li role="menuitem"><a class="dropdown-item" ngbDropdownItem  (click)="changeLang(item.code, myDrop); myDrop.close()">{{item.name}}</a></li>
        </div>

      </ul>
    </div>

    <div class="btn-group lang-btn" >
      <p class="nav-none">
        <a routerLink="/search">{{"NavMenu.Search" | translate}} <i class="fas fa-search" style="font-size: .9rem;"></i> </a>
      </p>
    </div>

    <div class="btn-group lang-btn" >
      <div class="btn-group lang-btn" ngbDropdown #myDrop="ngbDropdown">
        <div ngbDropdownToggle aria-controls="dropdown-basic">
          <p class="nav-none">MY ACCOUNT <i class="fas fa-user-circle" style="font-size: .9rem;"></i></p>


        </div>
        <ul   ngbDropdownMenu class="dropdown-menu translation "
          role="menu" aria-labelledby="button-animated">
          <div>
            <div *ngIf="loggedIn">
              <li style="margin: 1rem" role="menuitem"><a class="dropdown-item" ngbDropdownItem  (click)="myDrop.close()">{{userName}}</a></li>
              <hr>
                <li style="margin: .2rem" role="menuitem"><a class="dropdown-item" ngbDropdownItem  [href]="envService.profileUrl">View Profile</a></li>
                <li style="margin: .2rem" role="menuitem"><a class="dropdown-item" ngbDropdownItem  routerLink="efile/status">Status</a></li>
                <li style="margin: .2rem" role="menuitem"><a class="dropdown-item" ngbDropdownItem  href="{{ url }}/oamsso/logout.html?end_url={{ url }}">LOG OUT</a></li>
              </div>
              <div *ngIf="!loggedIn">
                <li role="menuitem"><a class="dropdown-item" ngbDropdownItem  (click)="login()">LOG IN</a></li>
              </div>


            </div>

          </ul>
        </div>
      </div>


    </div>



  </nav> -->
  <nav id="toolbar" class="nav-toolbar">
    <a id="lacounty-link" href="https://lacounty.gov">lacounty.gov</a>
    <div id="toolbar-options" class="toolbar-options">
      <div id="leading-nav-separator" class="nav-separator"></div>
      <div id="language-selector" class="toolbar-options-item" ngbDropdown #myDrop="ngbDropdown">
        <a ngbDropdownToggle aria-expanded="false">
          Language
          <i id="language-icon" class="fa-solid fa-language"></i>
        </a>
        <div class="dropdown-menu" ngbDropdownMenu>
          @for (item of languages; track item) {
            <div>
              <a ngbDropdownItem class="dropdown-item" style="margin-left: 10px" (click)="changeLang(item.code, myDrop); myDrop.close()"> {{item.name}}</a>
              <div class="dropdown-divider"></div>
            </div>
          }
        </div>
      </div>
      <div class="nav-separator"></div>
      <div id="search" class="toolbar-options-item">
        <a aria-label="Search" routerLink="/search">{{"NavMenu.Search" | translate}} <i id="search-icon"class="fas fa-search"></i></a>
      </div>
      <div class="nav-separator"></div>
      <div id="account-dropdown" class="toolbar-options-item" ngbDropdown #myDrop="ngbDropdown">
        @if (siteConfigService.isProfilePageDisabled()) {
          <a role="button"
            class="nav-link dropdown-toggle disabled-link"
            data-toggle="dropdown"
            aria-expanded="false"
            [ngbPopover]="siteConfigService.getProfileMaintenanceMessage()">
            My Account <i class="fas fa-user-circle"></i>
          </a>
        } @else {
          <a ngbDropdownToggle role="button" data-toggle="dropdown" aria-expanded="false">
            My Account <i id="account-icon"class="fas fa-user-circle"></i>
          </a>
        }

        <div class="dropdown-menu" ngbDropdownMenu>
          @if (!userService.isLoggedIn()) {
            <div >
              <a ngbDropdownItem class="dropdown-item" (click)="register()"><i class="fa-sharp fa-solid fa-user"></i> REGISTER</a>
              <div class="dropdown-divider"></div>
              <a ngbDropdownItem class="dropdown-item" (click)="login()"><i class="fas fa-sign-in"></i> SIGN IN</a>
            </div>
          } @else {
            <div>
              <a ngbDropdownItem class="dropdown-item" (click)="profile()"><i class="fa-sharp fa-solid fa-user"></i> Profile</a>
              <div class="dropdown-divider"></div>
              <a ngbDropdownItem class="dropdown-item" aria-label="eFile status" routerLink="efile/status"><i class="fa-solid fa-clipboard-list"></i> Status</a>
              <div class="dropdown-divider"></div>
              <a ngbDropdownItem class="dropdown-item" [href]="envService.logoutUrl"><i class="fa-sharp fa-solid fa-right-from-bracket"></i> SIGN OUT</a>
            </div>
          }
        </div>
      </div>
    </div>
  </nav>

  <div class="nav-banner">
    <div #toggleButton class="nav-collapse-button" [ngClass]="{'menu-icon': isCollapsed, 'close-icon': !isCollapsed}"  data-toggle="collapse" (click)="clicked()" [attr.aria-expanded]="!isCollapsed" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-label="Toggle navigation">
      <!-- <i  *ngIf="isCollapsed" class="fas fa-bars text-blue nav-icon"></i>
      <i  *ngIf="!isCollapsed" class="fas fa-times text-blue nav-icon"></i> -->
    </div>
    <div class="nav-items w-100">
      <div class="nav-img">
        <img style="" src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1624312500/News/header.webp" alt="">
      </div>

      <div class="nav-banner-line">
      </div>

    </div>
  </div>



  <nav class="large-nav navbar navbar-expand-md navbar-light bg-light">


    <div class=" collapse navbar-collapse" (click)="stopPropagation($event)" id="navbarNavDropdown" [class.collapse]="isCollapsed">
      <div class="navbar-nav navbar-menu w-100">
        <div class="btn-group" >
          <a routerLink="/" aria-label="Home" (click)= "isCollapsed = !isCollapsed"   class="underline">
            <p>{{'NavMenu.Home'|translate}}</p>
          </a>

        </div>
        <div class="btn-group" ngbDropdown>
          <a ngbDropdownToggle class="underline clear-fix">
            <p>{{'NavMenu.PropertyInfo'|translate}} <i class="float-end pr-4 fas fa-chevron-down"></i></p>

          </a>
          <ul  ngbDropdownMenu class="dropdown-menu mega-menu animate slideIn"
            role="menu" aria-labelledby="button-animated">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-4">
                  <div [ngClass]="{'menu-active': !toggleHome}" (click)="toggleHome = !toggleHome">
                    <h4 class="clearfix">
                      {{'Booking.Homeowners'|translate}}
                      @if (toggleHome) {
                        <i class="float-end pr-4 fas fa-plus"></i>
                      }
                      @if (!toggleHome) {
                        <i class="float-end pr-4 fas fa-minus"></i>
                      }
                    </h4>
                  </div>
                  <div class="mini-menu animate slideIn" [ngClass]="{'toggle-display': toggleHome}">
                    <p>
                      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem aria-label="New Homeowners"  routerLink="homeowners/new-homeowners">{{'NavMenu.NewHomeowners'|translate}}</a>
                    </p>
                    <p>
                      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem aria-label="Real Property" routerLink="homeowners/realproperty">{{'NavMenu.RealPropAssessment'|translate}}</a>
                    </p>
                    <p>
                      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem aria-label="Property Search" routerLink="homeowners/property-search">{{'NavMenu.PropSearchTool'|translate}}</a>
                    </p>
                    <p>
                      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Prop 19" routerLink="homeowners/proposition-19">{{'NavMenu.TransferringValue'|translate}}</a>
                    </p>
                    <p>
                      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Change Mailing Address" routerLink="homeowners/change-mailing-address">{{'NavMenu.ChangeMailingAdd'|translate}}</a>
                    </p>
                    <p>
                      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Change in Ownership" routerLink="homeowners/change-in-ownership">{{'NavMenu.ChangeOwnership'|translate}}</a>
                    </p>
                    <p>
                      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Death of an Owner" routerLink="homeowners/death-of-an-owner">{{'NavMenu.DeathofOwner'|translate}}</a>
                    </p>
                    <p>
                      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="New Contsruction" routerLink="homeowners/new-construction">{{'NavMenu.NewConst'|translate}}</a>
                    </p>
                    <p>
                      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="ADU" routerLink="homeowners/adu">{{'NavMenu.ADUv2'|translate}}</a>
                    </p>
                    <p>
                      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Homeowners' Exemption" routerLink="homeowners/homeowner-exemption">{{'NavMenu.HomeExv2'|translate}}</a>
                    </p>

                    <p>
                      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Contest Assessment" routerLink="homeowners/contest-assessment">{{'NavMenu.ContestValue'|translate}}</a>
                    </p>
                    <!-- <p>
                    <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem   routerLink="homeowners/supplemental-tax-estimator">{{'NavMenu.SupplementalEstimator'|translate}}</a>
                  </p> -->




                </div>
              </div>
              <div class="col-md-4">
                <h4 class="clearfix" [ngClass]="{'menu-active': !toggleBusiness}" (click)="toggleBusiness = !toggleBusiness">{{'NavMenu.BusinessOwners'|translate}}
                  @if (toggleBusiness) {
                    <i class="float-end pr-4 fas fa-plus"></i>
                  }
                  @if (!toggleBusiness) {
                    <i class="float-end pr-4 fas fa-minus"></i>
                  }
                </h4>
                <div class="mini-menu animate slideIn" [ngClass]="{'toggle-display': toggleBusiness}">
                  <p>
                    <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Business Property Filing" routerLink="businessowners/business-prop-statement-filing">{{'NavMenu.BusiPropStatementFiling'|translate}}</a>
                  </p>
                  <p>
                    <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Business Property Assessment" routerLink="businessowners/business-prop-assessments">{{'NavMenu.BusinessPropAssessment'|translate}}</a>
                  </p>
                  <p>
                    <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Important Dates" routerLink="businessowners/important-dates">{{'NavMenu.ImportantDatesBusinessOwners'|translate}}</a>
                  </p>

                  <p>
                    <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Manufactured Homes" routerLink="businessowners/manufactured-homes">{{'NavMenu.MobileHomes'|translate}}</a>
                  </p>
                  <p>
                    <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Marine and Aircraft" routerLink="businessowners/marine-aircraft">{{'NavMenu.MarineAircraft'|translate}}</a>
                  </p>
                  <p>
                    <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Trends" routerLink="businessowners/trends">{{'NavMenu.TrendFactors'|translate}}</a>
                  </p>
                </div>
              </div>
              <div class="col-md-4">
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Church" routerLink="/exemptions/church"><h4>{{'NavMenu.Churches'|translate}}</h4></a>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Disabled Transfer" routerLink="/tax-relief/disabled-transfer"><h4>{{'NavMenu.Disabled'|translate}}</h4></a>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Prop 19" routerLink="/homeowners/proposition-19"><h4>{{'NavMenu.Seniors'|translate}}</h4></a>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Veterans" routerLink="/exemptions/veterans"><h4>{{'Veterans.SearchTitle'|translate}}</h4></a>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Non-profit" routerLink="/exemptions/non-profit"><h4>{{'NavMenu.NonProfits'|translate}}</h4></a>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Possessory Interest" routerLink="/possessory-interest"><h4>{{'NavMenu.PossessoryInterest'|translate}}</h4></a>

                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Data Sales" routerLink="/real-estate-toolkit/data-sales"><h4>{{'DataSales.SearchTitle'|translate}}</h4></a>

              </div>
            </div>
          </div>
        </ul>
      </div>
      <div class="btn-group" ngbDropdown>
        <a class="underline clearfix" ngbDropdownToggle>
          <p class="">{{'NavMenu.TaxSavings'|translate}} <i class="float-end pr-4 fas fa-chevron-down"></i></p>
        </a>
        <div   ngbDropdownMenu class="dropdown-menu mega-menu animate slideIn"
          role="menu" aria-labelledby="button-animated">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-4" >
                <h4 class="clearfix" [ngClass]="{'menu-active': !toggleExemptions}" (click)="toggleExemptions = !toggleExemptions">{{'NavMenu.Exemptions'|translate}}
                  @if (toggleExemptions) {
                    <i class="float-end pr-4 fas fa-plus"></i>
                  }
                  @if (!toggleExemptions) {
                    <i class="float-end pr-4 fas fa-minus"></i>
                  }
                </h4>
                <div class="mini-menu animate slideIn" [ngClass]="{'toggle-display': toggleExemptions}">
                  <p>
                    <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Homeowners' Exemption" routerLink="/exemptions/homeowner-exemption">{{'NavMenu.HomeExv2'|translate}}</a>
                  </p>
                  <p>
                    <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Disabled Veteran" routerLink="/exemptions/disabled-veterans">{{'NavMenu.DisabledVets'|translate}}</a>
                  </p>
                  <p>
                    <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Church" routerLink="/exemptions/church">{{'NavMenu.Churches'|translate}}</a>
                  </p>
                  <!--<p>
                  <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem routerLink="/exemptions/religious">{{'NavMenu.Religious'|translate}}</a>
                </p>-->
                <p>
                  <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Non-profit" routerLink="/exemptions/non-profit">{{'NavMenu.NonProfits'|translate}}</a>
                </p>
                <!--<p>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem routerLink="/exemptions/welfare">Welfare</a>
              </p>
              <p>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem   routerLink="/exemptions/hospital-property">Hospital Property</a>
              </p>
              <p>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem   routerLink="/exemptions/multispecialty-clinics">Multispecialty Clinics</a>
              </p>
              <p>
                <a (click)= "isCollapsed = !isCollapsed"  routerLink="/exemptions/housing">Housing</a>
              </p>-->
              <p>
                <a (click)= "isCollapsed = !isCollapsed"  ngbDropdownItem aria-label="Veterans" routerLink="/exemptions/veterans">{{'Veterans.SearchTitle'|translate}}</a>
              </p>
            </div>

          </div>
          <div class="col-md-4">
            <h4 class="clearfix" [ngClass]="{'menu-active': !toggleTax}" (click)="toggleTax = !toggleTax">{{'NavMenu.TaxRelief'|translate}}
              @if (toggleTax) {
                <i class="float-end pr-4 fas fa-plus"></i>
              }
              @if (!toggleTax) {
                <i class="float-end pr-4 fas fa-minus"></i>
              }
            </h4>
            <div class="mini-menu animate slideIn" [ngClass]="{'toggle-display': toggleTax}">
              <p>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="DIV" routerLink="/tax-relief/decline-in-value">{{'NavMenu.DeclineinValue'|translate}}</a>
              </p>
              <p>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Prop 19" routerLink="tax-relief/prop19">{{'NavMenu.Transfer55Over'|translate}}</a>
              </p>
              <p>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Disabled Transfer" routerLink="/tax-relief/disabled-transfer">{{'NavMenu.Disabled'|translate}}</a>
              </p>
              <p>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Disaster Relief" routerLink="/tax-relief/disaster-relief">{{'NavMenu.DisasterRelief'|translate}}</a>
              </p>
              <p>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Mills Act" routerLink="/tax-relief/mills-act">{{'MillsAct.SearchTitle'|translate}}</a>
              </p>
              <p>
                <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Change in Ownership" routerLink="/tax-relief/change-in-ownership-rescission">{{'ChangeAddressRescission.SearchTitle'|translate}}</a>
              </p>

            </div>

          </div>
          <div class="col-md-4">
            <h4 class="clearfix" [ngClass]="{'menu-active': !toggleExclusions}" (click)="toggleExclusions = !toggleExclusions">
              @if (toggleExclusions) {
                <i class="float-end pr-4 fas fa-plus"></i>
              }
              @if (!toggleExclusions) {
                <i class="float-end pr-4 fas fa-minus"></i>
              }{{'NavMenu.Exclusions'|translate}}</h4>
              <div class="mini-menu animate slideIn" [ngClass]="{'toggle-display': toggleExclusions}">
                <p>
                  <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Prop 19" routerLink="exclusions/prop19">{{'NavMenu.ParentChild'|translate}}</a>
                </p>

                <p>
                  <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem   aria-label="Inter-spousal" routerLink="/exclusions/inter-spousal">{{'NavMenu.InterSpousal'|translate}}</a>
                </p>
                <p>
                  <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem   aria-label="Joint Tenancy" routerLink="/exclusions/joint-tenancy">{{'NavMenu.JointTenancy'|translate}}</a>
                </p>
                <p>
                  <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Registered Domestic Partners" routerLink="/exclusions/registered-domestic-partners">{{'NavMenu.Domestic'|translate}}</a>
                </p>
                <p>
                  <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Builders" routerLink="/exclusions/builders">{{'NavMenu.Builders'|translate}}</a>
                </p>
                <p>
                  <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem aria-label="Solar" routerLink="/exclusions/solar">{{'NavMenu.Solar'|translate}}</a>
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group" >
      <a (click)= "isCollapsed = !isCollapsed"  aria-label="Forms"  routerLink="/forms" class="underline">
        <p >{{'NavMenu.Forms'|translate}}</p>
      </a>
    </div>
    <!-- <div class="btn-group" >
    <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem   routerLink="/news-information" class="underline">
      <p>{{'NavMenu.NewsInfo'|translate}}</p>
    </a>
  </div> -->
  <div class="btn-group" ngbDropdown>
    <a ngbDropdownToggle class="underline">
      <p>{{'NavMenu.NewsInfo'|translate}}</p>
    </a>
    <ul   ngbDropdownMenu class="dropdown-menu mega-menu mini-news animate slideIn">
      <p>
        <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Newsroom" routerLink="news-information/newsroom">{{'NavMenu.Newsroom'|translate}}</a>
      </p>
      <p>
        <a  [innerHTML]="'Newsletters'" (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Newsletters" routerLink="news-information/newsletters"></a>
      </p>
      <p>
        <a  [innerHTML]="'Homeowner Alert Service'|translate" (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Enotification" routerLink="news-information/enotification"></a>
      </p>
      <p>
        <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Events" routerLink="news-information/events">{{'NavMenu.Events'|translate}}</a>
      </p>
      <p>
        <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Presentations" routerLink="news-information/webinars-presentations">{{'NavMenu.Webinars'|translate}}</a>
      </p>
      <p>
        <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Annual Roll" routerLink="news-information/annualroll">{{'NavMenu.AnnualReport'|translate}}</a>
      </p>
      <p>
        <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Assessment Roll" routerLink="news-information/assessmentroll">{{'NavMenu.AssessmentRoll'|translate}}</a>
      </p>
      <p>
        <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Awards" routerLink="news-information/awards">{{'NavMenu.Awards'|translate}}</a>
      </p>
      <p>
        <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Careers" routerLink="news-information/careers">{{'NavMenu.Careers'|translate}}</a>
      </p>
      <!-- <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem   routerLink="news-information/publicrecord">{{'PublicRecords.SearchTitle'|translate}}</a>
    </p> -->
  </ul>
</div>



<div class="btn-group" >
  <a (click)= "isCollapsed = !isCollapsed"  aria-label="Real Estate Toolkit"  routerLink="real-estate-toolkit/welcome" class="underline">
    <p>{{'NavMenu.RealEstateToolkit'|translate}}</p>
  </a>

</div>


<div class="btn-group" ngbDropdown>
  <a ngbDropdownToggle class="underline">
    <p>{{'NavMenu.Aboutus'|translate}}</p>
  </a>
  <ul   ngbDropdownMenu class="dropdown-menu mega-menu mini-about animate slideIn">
    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Meet the Assessor" routerLink="/about-us/meet-the-assessor">{{'NavMenu.Meetthe'|translate}}</a>
    </p>
    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Meet the Staff" routerLink="/about-us/meet-the-staff">{{'NavMenu.MeettheStaff'|translate}}</a>
    </p>
    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Property tax system" routerLink="/about-us/property-tax-system">{{'NavMenu.Proptax'|translate}}</a>
    </p>

  </ul>
</div>



<!--
<div class="btn-group" >
  <a (click)= "isCollapsed = !isCollapsed"    routerLink="/About-us/meet-the-assessor"class="underline">
    <p>{{'NavMenu.Aboutus'|translate}}</p>
  </a>
</div>
-->




<div class="btn-group" ngbDropdown>
  <a ngbDropdownToggle class="underline">
    <p>{{'NavMenu.Contact'|translate}}</p>
  </a>
  <ul   ngbDropdownMenu class="dropdown-menu mega-menu mini-contact animate slideIn">
    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="contact the Assessor" routerLink="contact/assessor">{{'NavMenu.ContacttheAssessor'|translate}}</a>
    </p>
    <p>
      <a (click)= "isCollapsed = !isCollapsed; chatService.openChatBot();" ngbDropdownItem aria-label="Ask the Chatbot" >{{'Ask The ChatBot'|translate}}</a>
    </p>
    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem aria-label="Disaster Relief Contact" routerLink="/contact/assessor/3">{{'NavMenu.DisasterRelief'|translate}}</a>
    </p>
    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Book an appointment" routerLink="contact/appointment">{{ 'ContactAssessor.Bookingsv2' | translate}}</a>
    </p>
    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Find your district" routerLink="contact/district-office">{{'NavMenu.FindDistrictoffice'|translate}}</a>
    </p>
    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Office Locations" routerLink="contact/officelocations">{{'NavMenu.OfficeLoc'|translate}}</a>
    </p>
    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Public records" routerLink="contact/publicrecord">{{'PublicRecords.SearchTitle'|translate}}</a>
    </p>

    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Request a speaker" routerLink="contact/requestspeaker">{{'NavMenu.Requestaspreaker'|translate}}</a>
    </p>

    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Request a certificate" routerLink="contact/requestcertificate">{{'NavMenu.RequestCert'|translate}}</a>
    </p>

    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Directory" routerLink="contact/directory">{{ 'Directory.SearchTitle' |translate }}</a>
    </p>
    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="We want your feedback" routerLink="contact/feedback">{{'NavMenu.Feedback'|translate}}</a>
    </p>
    <p>
      <a (click)= "isCollapsed = !isCollapsed" ngbDropdownItem  aria-label="Language Access" routerLink="contact/languageaccess">{{'LanguageAccess.SearchTitle'|translate}}</a>
    </p>

  </ul>
</div>

</div>
</div>
</nav>


</header>
